import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Auth0Account } from 'src/app/accounts/interfaces/accounts.types';
import { FeatureActivePipe } from '../../../shared/pipes/feature-active.pipe';
import { LokaliseTranslatePipe } from '../../../lokalise/lokalise-translate.pipe';
import { GpsCartCountBadgeModule } from '@geneplanet/ngx-shop/src/lib/cart-count-badge';
import { NgClass } from '@angular/common';
import { AnalyticsModule } from '@geneplanet/ngx-utils';

@Component({
  selector: 'app-mobile-footer',
  templateUrl: './mobile-footer.component.html',
  styleUrls: ['./mobile-footer.component.scss'],
  imports: [
    RouterLink,
    AnalyticsModule,
    NgClass,
    GpsCartCountBadgeModule,
    LokaliseTranslatePipe,
    FeatureActivePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileFooterComponent {
  private router = inject(Router);

  readonly account = input<Auth0Account>(undefined);

  dashboardUrl = '/dashboard';
  resultsUrl = '/results';
  addDataUrl = '/add-data';
  cartUrl = '/cart';

  isActive(route: string): boolean {
    return this.router.isActive(route, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
